import {EXPLORE_CAMERA_ANGLE} from './HomepageAssets/ExploreRemotion/camera-angle';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const VideoPlaybackPreview = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 4092,
				height: 2876,
				translate: '-1012.5px -1035.3px',
				scale: 0.551,
				rotate: EXPLORE_CAMERA_ANGLE,
			}}
			from={-455}
		>
			<Video
				src="https://remotion.media/studio-close-ups/video-playback-2026-09-22.webm"
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						-434, -366, -363, -357, -356, -355, -354, -303, -302, -300, -282,
						-271, -264, -256, -213, -211, -203, -192, -80, -79, -72, -8,
					],
					[
						'auto',
						'col-resize',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
						'row-resize',
						'col-resize',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
						'default',
						'auto',
					],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-455, -341, -333, -49, -39, 313, 320],
						[3.4, 3.06, 3.4, 3.06, 3.4, 3.06, 3.4],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-434, -433, -432, -431, -430, -429, -428, -427, -426, -425, -424,
							-423, -422, -421, -420, -419, -418, -417, -405, -404, -403, -402,
							-401, -400, -399, -398, -397, -396, -395, -394, -393, -392, -391,
							-390, -389, -388, -387, -386, -385, -384, -383, -382, -381, -380,
							-379, -378, -377, -376, -375, -374, -373, -372, -371, -370, -369,
							-368, -367, -366, -365, -364, -363, -362, -361, -360, -359, -358,
							-357, -356, -355, -354, -353, -352, -351, -350, -349, -348, -347,
							-336, -335, -307, -306, -305, -304, -303, -302, -301, -300, -299,
							-298, -297, -296, -295, -294, -293, -292, -290, -289, -288, -287,
							-286, -285, -284, -283, -282, -281, -280, -273, -272, -271, -270,
							-269, -268, -267, -266, -265, -264, -263, -262, -261, -260, -259,
							-258, -257, -256, -255, -254, -253, -252, -251, -250, -249, -248,
							-247, -246, -245, -244, -243, -242, -241, -240, -239, -238, -237,
							-236, -235, -234, -233, -232, -231, -230, -229, -228, -227, -226,
							-225, -224, -223, -222, -221, -220, -219, -218, -217, -216, -215,
							-214, -213, -212, -211, -210, -209, -208, -207, -206, -205, -204,
							-203, -202, -201, -200, -199, -198, -197, -194, -193, -192, -191,
							-190, -189, -188, -187, -186, -185, -184, -183, -182, -181, -180,
							-168, -167, -166, -165, -164, -163, -162, -161, -160, -159, -158,
							-157, -156, -155, -154, -153, -152, -151, -150, -149, -148, -147,
							-146, -145, -144, -143, -140, -139, -138, -137, -136, -135, -134,
							-133, -132, -131, -130, -129, -128, -127, -126, -125, -124, -123,
							-122, -121, -120, -119, -118, -117, -116, -115, -114, -113, -112,
							-111, -110, -109, -108, -107, -106, -105, -104, -103, -102, -101,
							-100, -99, -98, -97, -96, -95, -94, -93, -92, -91, -90, -89, -88,
							-87, -86, -85, -84, -83, -82, -81, -80, -79, -78, -77, -76, -75,
							-74, -73, -72, -69, -68, -67, -10, -9, -8, -7, -6, -5, -4, -3, -2,
							-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
							18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
							34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 238,
							239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251,
							252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264,
							265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277,
							278, 279, 280, 281, 282, 283, 284,
						],
						[
							'3023.88828125px 3781.6765625px',
							'3023.88828125px 3781.6765625px',
							'3030.090625px 3765.11484375px',
							'3037.14296875px 3754.27734375px',
							'3051.91171875px 3738.97734375px',
							'3068.6593749999997px 3724.23515625px',
							'3082.21953125px 3714.871875px',
							'3153.03515625px 3664.66875px',
							'3226.26796875px 3612.234375px',
							'3310.76328125px 3550.41015625px',
							'3370.92734375px 3507.21953125px',
							'3414.09140625px 3464.6px',
							'3460.54921875px 3424.18515625px',
							'3519.14609375px 3385.7625px',
							'3560.47734375px 3359.465625px',
							'3588.2484375px 3344.89609375px',
							'3598.475px 3340.1546875px',
							'3598.8468749999997px 3340.00859375px',
							'3598.8468749999997px 3340.00859375px',
							'3595.553125px 3342.63828125px',
							'3582.20546875px 3353.0375px',
							'3561.7257812499997px 3365.45546875px',
							'3504.7492187499997px 3375.5890624999997px',
							'3324.1375px 3365.21640625px',
							'3083.5078125px 3320.6046874999997px',
							'2658.17578125px 3216.1476562499997px',
							'2342.87890625px 3151.44140625px',
							'1987.6453125px 3079.7492187499997px',
							'1754.240625px 3029.71875px',
							'1754.240625px 3029.71875px',
							'1527.184375px 2992.2257812499997px',
							'1453.3804687499999px 2989.7953125px',
							'1417.97265625px 2998.6671874999997px',
							'1394.2789062499999px 3012.984375px',
							'1359.00390625px 3059.24296875px',
							'1338.6171875px 3109.57890625px',
							'1325.4156249999999px 3164.178125px',
							'1321.64375px 3216.93125px',
							'1321.71015625px 3231.31484375px',
							'1321.8296874999999px 3233.9445312499997px',
							'1320.40859375px 3227.8351562499997px',
							'1319.18671875px 3209.3875px',
							'1319.0406249999999px 3158.93203125px',
							'1316.75625px 3074.3039062499997px',
							'1316.75625px 3074.3039062499997px',
							'1301.35px 2925.8195312499997px',
							'1293.7796875px 2863.6765625px',
							'1279.303125px 2816.2359375px',
							'1265.8890625px 2781.42578125px',
							'1244.5992187499999px 2735.246875px',
							'1225.89921875px 2699.759375px',
							'1192.90859375px 2627.20390625px',
							'1169.1484375px 2559.07109375px',
							'1167.475px 2555.41875px',
							'1155.3359375px 2547.41015625px',
							'1145.9328125px 2541.5265624999997px',
							'1131.94765625px 2532.3624999999997px',
							'1116.846875px 2523.71640625px',
							'1104.7875px 2516.65078125px',
							'1104.7875px 2516.65078125px',
							'1083.86953125px 2504.45859375px',
							'1074.9046875px 2497.725px',
							'1061.809375px 2480.8578125px',
							'1052.3531249999999px 2450.975px',
							'1050.0953124999999px 2409.1390625px',
							'1050.0953124999999px 2409.1390625px',
							'1061.13203125px 2301.428125px',
							'1069.8578125px 2263.5765625px',
							'1073.6828125px 2242.5390625px',
							'1076.3257812499999px 2228.8859374999997px',
							'1077.48125px 2222.94921875px',
							'1079.4734375px 2214.8742187499997px',
							'1079.5px 2214.71484375px',
							'1079.659375px 2213.93125px',
							'1079.7921875px 2213.4265625px',
							'1080.1109374999999px 2212.8820312499997px',
							'1080.2171875px 2212.7625px',
							'1080.2171875px 2212.7625px',
							'1080.2171875px 2212.2578125px',
							'1080.2171875px 2212.2578125px',
							'1080.54921875px 2214.82109375px',
							'1083.5375px 2227.41171875px',
							'1083.5375px 2227.41171875px',
							'1092.14375px 2245.52734375px',
							'1111.8796875px 2282.4625px',
							'1111.8796875px 2282.4625px',
							'1288.21484375px 2618.73046875px',
							'1392.3px 2865.04453125px',
							'1441.653125px 3018.49609375px',
							'1460.26015625px 3110.309375px',
							'1480.2484375px 3223.9835937499997px',
							'1489.31953125px 3276.0859375px',
							'1493.45px 3308.4921875px',
							'1493.45px 3317.4835937499997px',
							'1493.45px 3320.64453125px',
							'1493.45px 3320.64453125px',
							'1496.796875px 3317.56328125px',
							'1536.1625px 3273.5625px',
							'1692.3101562499999px 3124.87890625px',
							'1984.84296875px 2865.0578124999997px',
							'1984.84296875px 2865.0578124999997px',
							'2516.06640625px 2301.62734375px',
							'2592.40703125px 2203.7046875px',
							'2625.6632812499997px 2156.34375px',
							'2633.5125px 2144.7625px',
							'2633.778125px 2144.3507812499997px',
							'2633.778125px 2144.3507812499997px',
							'2632.3703124999997px 2143.009375px',
							'2624.69375px 2137.15234375px',
							'2624.69375px 2137.15234375px',
							'2619.79296875px 2135.8640625px',
							'2607.1890625px 2133.446875px',
							'2597.0421874999997px 2132.58359375px',
							'2585.6203124999997px 2132.31796875px',
							'2556.9992187499997px 2136.75390625px',
							'2506.0390625px 2153.27578125px',
							'2471.78671875px 2168.1242187499997px',
							'2455.11875px 2180.9671875px',
							'2451.43984375px 2184.6328125px',
							'2444.49375px 2191.6984374999997px',
							'2439.553125px 2197.58203125px',
							'2438.21171875px 2204.14296875px',
							'2437.9328124999997px 2215.6578125px',
							'2439.75234375px 2234.61015625px',
							'2442.740625px 2256.00625px',
							'2448.70390625px 2283.525px',
							'2453.1px 2311.18984375px',
							'2458.678125px 2343.54296875px',
							'2470.83046875px 2388.69921875px',
							'2483.7796875px 2439.234375px',
							'2491.2171875px 2493.72734375px',
							'2491.54921875px 2510.93984375px',
							'2491.54921875px 2521.41875px',
							'2491.084375px 2527.9265625px',
							'2490.978125px 2528.6437499999997px',
							'2490.978125px 2528.6437499999997px',
							'2490.7257812499997px 2528.55078125px',
							'2488.9328124999997px 2527.209375px',
							'2485.1875px 2521.2328125px',
							'2479.35703125px 2510.6476562499997px',
							'2470.11328125px 2494.09921875px',
							'2465.6640625px 2482.1859375px',
							'2463.140625px 2473.553125px',
							'2460.60390625px 2465.3984375px',
							'2458.4921875px 2456.81875px',
							'2456.7390625px 2446.1007812499997px',
							'2455.8890625px 2437.9859375px',
							'2455.3046875px 2427.85234375px',
							'2454.68046875px 2416.3507812499997px',
							'2454.38828125px 2400.3734375px',
							'2453.95px 2383.86484375px',
							'2453.790625px 2366.93125px',
							'2453.790625px 2355.23046875px',
							'2453.790625px 2343.9546875px',
							'2453.790625px 2333.196875px',
							'2453.59140625px 2323.35546875px',
							'2453.32578125px 2313.2882812499997px',
							'2454.22890625px 2306.8734375px',
							'2456.2078125px 2298.51953125px',
							'2456.9515625px 2290.52421875px',
							'2456.9515625px 2281.7984375px',
							'2456.9515625px 2276.02109375px',
							'2456.91171875px 2271.55859375px',
							'2456.43359375px 2267.52109375px',
							'2455.703125px 2263.125px',
							'2455.0125px 2257.02890625px',
							'2454.321875px 2252.0617187499997px',
							'2453.88359375px 2247.50625px',
							'2453.365625px 2241.6890625px',
							'2453.0734374999997px 2238.9265625px',
							'2453.03359375px 2235.9515625px',
							'2453.03359375px 2234.1453125px',
							'2453.11328125px 2231.63515625px',
							'2453.41875px 2228.7531249999997px',
							'2453.41875px 2227.06640625px',
							'2453.21953125px 2224.4765625px',
							'2452.834375px 2221.80703125px',
							'2452.36953125px 2218.30078125px',
							'2452.18359375px 2217.4109375px',
							'2451.8781249999997px 2216.49453125px',
							'2451.83828125px 2215.4453125px',
							'2451.57265625px 2214.9140625px',
							'2451.57265625px 2214.79453125px',
							'2451.57265625px 2214.79453125px',
							'2451.57265625px 2216.09609375px',
							'2450.7492187499997px 2232.59140625px',
							'2450.7492187499997px 2232.59140625px',
							'2450.390625px 2258.4234375px',
							'2443.94921875px 2337.871875px',
							'2427.13515625px 2450.178125px',
							'2399.11171875px 2580.08203125px',
							'2365.2578125px 2706.12109375px',
							'2332.9445312499997px 2839.796875px',
							'2312.5046875px 2926.58984375px',
							'2283.03359375px 3031.9765625px',
							'2254.8507812499997px 3108.45px',
							'2149.84921875px 3210.7023437499997px',
							'2121.3875px 3224.634375px',
							'2121.3875px 3224.634375px',
							'2121.05546875px 3225.28515625px',
							'2138.1749999999997px 3224.9px',
							'2147.153125px 3224.43515625px',
							'2147.2726562499997px 3224.5546875px',
							'2148.4679687499997px 3225.75px',
							'2148.4679687499997px 3226.015625px',
							'2149.3046875px 3230.2257812499997px',
							'2156.396875px 3243.3078124999997px',
							'2166.490625px 3254.8624999999997px',
							'2183.15859375px 3268.4890625px',
							'2219.36328125px 3289.553125px',
							'2219.36328125px 3289.553125px',
							'2403.0296875px 3341.4296875px',
							'2403.0296875px 3341.4296875px',
							'2593.509375px 3345.8390624999997px',
							'2730.7843749999997px 3340.53984375px',
							'2780.9609375px 3337.37890625px',
							'2805.17265625px 3335.4796874999997px',
							'2820.73828125px 3332.73046875px',
							'2831.41640625px 3330.41953125px',
							'2840.44765625px 3326.421875px',
							'2844.51171875px 3323.96484375px',
							'2844.525px 3323.93828125px',
							'2844.525px 3323.64609375px',
							'2844.525px 3322.98203125px',
							'2844.525px 3322.98203125px',
							'2842.5859375px 3321.428125px',
							'2839.1859375px 3318.1476562499997px',
							'2836.59609375px 3315.19921875px',
							'2831.15078125px 3309.209375px',
							'2825.3734375px 3303.29921875px',
							'2817.76328125px 3294.0953125px',
							'2813.6328125px 3288.10546875px',
							'2810.35234375px 3280.18984375px',
							'2806.5671875px 3270.9328124999997px',
							'2803.07421875px 3263.8273437499997px',
							'2798.63828125px 3253.375px',
							'2793.8703124999997px 3243.121875px',
							'2786.52578125px 3227.11796875px',
							'2781.3195312499997px 3207.80703125px',
							'2775.6749999999997px 3177.3796875px',
							'2768.91484375px 3141.7328125px',
							'2756.7625px 3105.2625px',
							'2744.5171875px 3076.5484375px',
							'2732.8429687499997px 3053.21328125px',
							'2718.1140625px 3024.52578125px',
							'2692.9328124999997px 2982.9421875px',
							'2665.29453125px 2940.48203125px',
							'2651.575px 2909.3640625px',
							'2638.06796875px 2870.33046875px',
							'2627.86796875px 2835.7062499999997px',
							'2615.75546875px 2790.9484374999997px',
							'2608.63671875px 2756.80234375px',
							'2596.01953125px 2717.45px',
							'2585.50078125px 2695.5890624999997px',
							'2560.26640625px 2648.6796875px',
							'2552.86875px 2633.459375px',
							'2549.203125px 2617.85390625px',
							'2544.475px 2596.1789062499997px',
							'2536.8515625px 2577.13359375px',
							'2529.85234375px 2558.61953125px',
							'2529.85234375px 2558.61953125px',
							'2524.8984375px 2531.2999999999997px',
							'2524.340625px 2521.7640625px',
							'2520.5421874999997px 2501.8421875px',
							'2512.18828125px 2479.9546875px',
							'2500.97890625px 2455.98203125px',
							'2491.1109375px 2441.4921875px',
							'2483.3015625px 2428.88828125px',
							'2481.18984375px 2419.684375px',
							'2480.5921875px 2407.87734375px',
							'2480.3796875px 2395.97734375px',
							'2479.13125px 2379.74765625px',
							'2479.13125px 2379.74765625px',
							'2479.01171875px 2366.33359375px',
							'2479.2109375px 2355.084375px',
							'2479.9015624999997px 2340.35546875px',
							'2480.28671875px 2323.2492187499997px',
							'2479.078125px 2308.82578125px',
							'2477.1921875px 2295.478125px',
							'2476.22265625px 2288.1203124999997px',
							'2475.7843749999997px 2282.66171875px',
							'2475.61171875px 2276.41953125px',
							'2474.24375px 2266.56484375px',
							'2470.91015625px 2259.6984374999997px',
							'2463.671875px 2248.71484375px',
							'2456.2609374999997px 2239.9625px',
							'2454.38828125px 2237.465625px',
							'2453.95px 2235.6859375px',
							'2453.16640625px 2232.0070312499997px',
							'2451.78515625px 2228.80625px',
							'2449.9125px 2226.13671875px',
							'2447.0171875px 2223.21484375px',
							'2446.87109375px 2222.9359375px',
							'2446.87109375px 2222.9359375px',
							'2446.87109375px 2219.3234374999997px',
							'2446.87109375px 2218.7257812499997px',
							'2446.87109375px 2218.7257812499997px',
							'2447.9734375px 2220.74453125px',
							'2460.059375px 2237.3859374999997px',
							'2491.9078125px 2275.75546875px',
							'2532.4953124999997px 2328.00390625px',
							'2595.30234375px 2435.13046875px',
							'2650.5656249999997px 2547.75546875px',
							'2711.18125px 2671.5499999999997px',
							'2774.8515625px 2774.8515625px',
							'2821.50859375px 2839.25234375px',
							'2853.51640625px 2881.2875px',
							'2866.13359375px 2901.6609375px',
							'2871.87109375px 2912.6710937499997px',
							'2874.36796875px 2917.7578125px',
							'2877.02421875px 2920.8390624999997px',
							'2877.834375px 2921.67578125px',
							'2878.85703125px 2923.37578125px',
							'2878.9234375px 2923.48203125px',
							'2879.5078125px 2924.2257812499997px',
							'2881.60625px 2927.73203125px',
							'2885.63046875px 2934.16015625px',
							'2888.44609375px 2938.35703125px',
							'2890.2125px 2941.41171875px',
							'2892.5234375px 2945.2765624999997px',
							'2896.30859375px 2950.1109375px',
							'2902.9093749999997px 2959.26171875px',
							'2909.2046875px 2967.33671875px',
							'2919.92265625px 2981.91953125px',
							'2929.7640625px 2994.98828125px',
							'2943.3640625px 3013.66171875px',
							'2950.7882812499997px 3026.67734375px',
							'2959.89921875px 3042.37578125px',
							'2968.66484375px 3058.12734375px',
							'2986.67421875px 3087.3859374999997px',
							'3001.01796875px 3111.2921874999997px',
							'3019.47890625px 3146.9125px',
							'3029.30703125px 3170.446875px',
							'3034.9249999999997px 3188.09765625px',
							'3034.9249999999997px 3188.09765625px',
							'3045.58984375px 3222.9210937499997px',
							'3051.2875px 3239.84140625px',
							'3055.9890625px 3252.0070312499997px',
							'3060.25234375px 3267.6789062499997px',
							'3061.76640625px 3274.10703125px',
							'3062.9484374999997px 3279.92421875px',
							'3063.240625px 3283.0453125px',
							'3063.7453124999997px 3288.7296874999997px',
							'3064.0640625px 3293.75px',
							'3064.25px 3296.884375px',
							'3064.42265625px 3298.6906249999997px',
							'3064.42265625px 3299.0359375px',
							'3064.42265625px 3299.115625px',
							'3064.42265625px 3299.275px',
							'3064.9406249999997px 3301.91796875px',
							'3065.2062499999997px 3303.7640625px',
							'3065.3125px 3305.384375px',
							'3065.48515625px 3306.51328125px',
							'3065.6578125px 3307.24375px',
							'3065.75078125px 3307.44296875px',
							'3065.75078125px 3307.44296875px',
							'3064.78125px 3310.3117187499997px',
							'3057.41015625px 3350.79296875px',
							'3051.96484375px 3382.9203125px',
							'3047.52890625px 3420.2140624999997px',
							'3045.0984375px 3461.2px',
							'3044.60703125px 3488.134375px',
							'3044.60703125px 3513.9132812499997px',
							'3043.7570312499997px 3530.75390625px',
							'3042.9203125px 3548.0859375px',
							'3042.8273437499997px 3569.46875px',
							'3042.840625px 3599.271875px',
							'3043.46484375px 3620.98671875px',
							'3043.46484375px 3638.03984375px',
							'3042.8671875px 3651.82578125px',
							'3042.203125px 3663.3273437499997px',
							'3042.203125px 3668.1484375px',
							'3041.4992187499997px 3673.1421875px',
							'3040.2109375px 3682.4125px',
							'3039.26796875px 3689.43828125px',
							'3038.1124999999997px 3692.09453125px',
							'3035.81484375px 3695.5343749999997px',
							'3031.578125px 3702.0421874999997px',
							'3027.8195312499997px 3707.52734375px',
							'3027.8195312499997px 3707.52734375px',
							'3021.39140625px 3717.953125px',
							'3021.39140625px 3717.953125px',
							'3017.08828125px 3727.1703125px',
							'3017.08828125px 3727.1703125px',
							'3013.05078125px 3736.5203125px',
							'3010.4609375px 3742.69609375px',
							'3008.90703125px 3746.0031249999997px',
							'3008.90703125px 3746.0031249999997px',
							'3006.01171875px 3753.79921875px',
							'3005.69296875px 3755.9640624999997px',
							'3005.40078125px 3757.4249999999997px',
							'3005.34765625px 3758.328125px',
							'3004.5375px 3760.43984375px',
							'3004.0859375px 3762.4054687499997px',
							'3003.3953125px 3764.5304687499997px',
							'3003.08984375px 3765.7257812499997px',
							'3002.87734375px 3766.54921875px',
							'3002.87734375px 3766.7218749999997px',
							'3002.87734375px 3767.08046875px',
							'3002.87734375px 3767.4390625px',
							'3002.571875px 3767.50546875px',
							'3002.53203125px 3767.50546875px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const VideoPlayback = () => {
	return (
		<Composition
			id="VideoPlayback"
			component={VideoPlaybackPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={120}
		/>
	);
};
